<template>
    <div class="plateorder">
        <div class="plateorder-tabs vue_flex vue_flex_between vue_align_center">
            <ul class="plateorder-tabs-boxs vue_flex">
                <li class="vue_relative h" :class="activeName === tabs.activeVal ? 'active' : 'activenot'"
                    v-for="(tabs, tabsIndex) in tabsList" :key="tabsIndex" @click="handleClick(tabs)">
                    <p class="vue-font-PingFang-bold">{{ tabs.title }}</p>
                    <div class="vue_absolute" v-if="activeName === tabs.activeVal"></div>
                </li>
            </ul>
            <div class="plateorder-tabs-input vue_flex vue_align_center">
                <div class="top_bar_inp vue_flex vue_align_center">
                    <img class="top_bar_inp_img1 h" src="../../../../../assets/yimou/ss.png" alt=""
                        @click="activeFun" />
                    <input type="text" class="top_bar_inp_inp" v-model="searchValue" placeholder="主体ID、主体名称关键字查询" />
                </div>
                <div class="plateorder-tabs-input-but vue-font-PingFang-500 color_255 h"
                    @click="dialogimportVisible = true">
                    导入账单
                </div>
            </div>
        </div>

        <!-- 批量删除按钮 - 增加margin-top:20px -->
        <div class="batch-delete-container" style="margin-top: 20px; margin-bottom: 15px; text-align: right;">
            <el-button type="danger" size="small" @click="batchDelete" :loading="batchDeleteLoading"
                icon="el-icon-delete" :disabled="selectedRows.length === 0">
                批量删除 (已选{{ selectedRows.length }}条)
            </el-button>
        </div>

        <div class="width_100" v-if="activeName === 'taobao'" style="margin-top: 28px">
            <el-table :data="dataList" style="width: 100%" :header-cell-style="headercellstyle" border height="70vh"
                :key="'taobaoTable'" ref="orderTable" @selection-change="handleSelectionChange">
                <!-- 批量选择列 -->
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="tb_riqi" label="日期" align="center"></el-table-column>
                <el-table-column prop="tb_zhutiID" label="主体ID" align="center"></el-table-column>
                <el-table-column prop="tb_zhutileixing" label="主体类型" align="center"></el-table-column>
                <el-table-column prop="tb_zhutimingcheng" label="主体名称" align="center"></el-table-column>
                <el-table-column prop="tb_zhanxianliang" label="展现量" align="center"></el-table-column>

                <el-table-column prop="tb_dianjiliang" label="点击量" align="center"></el-table-column>
                <el-table-column prop="tb_huafei" label="花费" align="center"></el-table-column>
                <el-table-column prop="tb_dianjilyu" label="点击率" align="center"></el-table-column>
                <el-table-column prop="tb_pingjundianjihuafei" label="平均点击花费" align="center"></el-table-column>
                <el-table-column prop="tb_qiancizhanxianhuafei" label="千次展现花费" align="center"></el-table-column>
                <el-table-column prop="tb_zongyushouchengjiaojine" label="总预售成交金额" align="center"></el-table-column>
                <el-table-column prop="tb_zhijieyushouchengjiaojine" label="直接预售成交金额" align="center"></el-table-column>
                <el-table-column prop="tb_jianjieyushouchengjiaojine" label="间接预售成交金额" align="center"></el-table-column>
                <el-table-column prop="tb_jianjieyushouchengjiaobishu" label="间接预售成交笔数"
                    align="center"></el-table-column>
                <el-table-column prop="tb_zhijiechengjiaojine" label="直接成交金额" align="center"></el-table-column>
                <el-table-column prop="tb_jianjiechengjiaojine" label="间接成交金额" align="center"></el-table-column>
                <el-table-column prop="tb_zongchengjiaojine" label="总成交金额" align="center"></el-table-column>
                <el-table-column prop="tb_zongchengjiaobishu" label="总成交笔数" align="center"></el-table-column>
                <el-table-column prop="tb_zhijiechengjiaobishu" label="直接成交笔数" align="center"></el-table-column>
                <el-table-column prop="tb_jianjiechengjiaobishu" label="间接成交笔数" align="center"></el-table-column>
                <el-table-column prop="tb_dianjizhuanhualyu" label="点击转化率" align="center"></el-table-column>
                <el-table-column prop="tb_touruchanchubi" label="投入产出比" align="center"></el-table-column>
                <el-table-column prop="tb_zongchengjiaochengben" label="总成交成本" align="center"></el-table-column>


                <el-table-column prop="tb_zonggouwucheshu" label="总购物车数" align="center"></el-table-column>
                <el-table-column prop="tb_zhijiegouwucheshu" label="直接购物车数" align="center"></el-table-column>
                <el-table-column prop="tb_jianjiegouwucheshu" label="间接购物车数" align="center"></el-table-column>
                <el-table-column prop="tb_zongchengjiaochengben" label="加购率" align="center"></el-table-column>
                <el-table-column prop="tb_shoucangbaobeishu" label="收藏宝贝数" align="center"></el-table-column>
                <el-table-column prop="tb_shoucangdianpushu" label="收藏店铺数" align="center"></el-table-column>
                <el-table-column prop="tb_zongshoucangjiagoushu" label="总收藏加购数" align="center"></el-table-column>
                <el-table-column prop="tb_zongshoucangjiagouchengben" label="总收藏加购成本" align="center"></el-table-column>
                <el-table-column prop="tb_baobeishoucangjiagoushu" label="宝贝收藏加购数" align="center"></el-table-column>
                <el-table-column prop="tb_baobeishoucangjiagouchengben" label="宝贝收藏加购成本"
                    align="center"></el-table-column>
                <el-table-column prop="tb_zongshoucangshu" label="总收藏数" align="center"></el-table-column>
                <el-table-column prop="tb_baobeishoucangchengben" label="宝贝收藏成本" align="center"></el-table-column>
                <el-table-column prop="tb_baobeishoucanglyu" label="宝贝收藏率" align="center"></el-table-column>
                <el-table-column prop="tb_jiagouchengben" label="加购成本" align="center"></el-table-column>
                <el-table-column prop="tb_paixiadingdanbishu" label="拍下订单笔数" align="center"></el-table-column>
                <el-table-column prop="tb_paixiadingdanjine" label="拍下订单金额" align="center"></el-table-column>
                <el-table-column prop="tb_zhijieshoucangbaobeishu" label="直接收藏宝贝数" align="center"></el-table-column>
                <el-table-column prop="tb_jianjieshoucangbaobeishu" label="间接收藏宝贝数" align="center"></el-table-column>
                <el-table-column prop="tb_youhuiquanlingquliang" label="优惠券领取量" align="center"></el-table-column>
                <el-table-column prop="tb_gouwujinchongzhibishu" label="购物金充值笔数" align="center"></el-table-column>
                <el-table-column prop="tb_gouwujinchongzhijine" label="购物金充值金额" align="center"></el-table-column>

                <el-table-column prop="tb_wangwangzixunliang" label="旺旺咨询量" align="center"></el-table-column>
                <el-table-column prop="tb_yindaofangwenliang" label="引导访问量" align="center"></el-table-column>
                <el-table-column prop="tb_yindaofangwenrenshu" label="引导访问人数" align="center"></el-table-column>
                <el-table-column prop="tb_yindaofangwenqiankeshu" label="引导访问潜客数" align="center"></el-table-column>
                <el-table-column prop="tb_yindaofangwenqiankezhanbi" label="引导访问潜客占比" align="center"></el-table-column>
                <el-table-column prop="tb_ruhuilyu" label="入会率" align="center"></el-table-column>
                <el-table-column prop="tb_ruhuiliang" label="入会量" align="center"></el-table-column>
                <el-table-column prop="tb_yindaofangwenlyu" label="引导访问率" align="center"></el-table-column>
                <el-table-column prop="tb_shendufangwenliang" label="深度返问量" align="center"></el-table-column>
                <el-table-column prop="tb_pingjunfangwenyemianshu" label="平均返问页面数" align="center"></el-table-column>
                <el-table-column prop="tb_chengjiaoxinkeshu" label="成交新客数" align="center"></el-table-column>
                <el-table-column prop="tb_chengjiaoxinkezhanbi" label="成交新客占比" align="center"></el-table-column>
                <el-table-column prop="tb_huiyuanshougourenshu" label="会员首购人数" align="center"></el-table-column>
                <el-table-column prop="tb_huiyuanchengjiaojine" label="会员成交金额" align="center"></el-table-column>
                <el-table-column prop="tb_huiyuanchengjiaobishu" label="会员成交笔数" align="center"></el-table-column>
                <el-table-column prop="tb_chengjiaorenshu" label="成交人数" align="center"></el-table-column>
                <el-table-column prop="tb_renjunchengjiaobishu" label="人均成交笔数" align="center"></el-table-column>
                <el-table-column prop="tb_renjunchengjiaojine" label="人均成交金额" align="center"></el-table-column>
                <el-table-column prop="tb_ziranliuliangzhuanhuajine" label="自然流量转化金额" align="center"></el-table-column>
                <el-table-column prop="tb_ziranliuliangpuguangliang" label="自然流量曝光量" align="center"></el-table-column>
                <el-table-column align="center" label="操作" width="160" class-name="small-padding fixed-width">
                    <template slot-scope="row">
                        <el-button type="danger" size="small" @click="handleDelete(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="width_100" v-if="activeName === 'jingdong'">
            <el-table :data="dataList" style="width: 100%" :header-cell-style="headercellstyle" border height="70vh"
                :key="'jingdongTable'" ref="orderTable" @selection-change="handleSelectionChange">
                <!-- 批量选择列 -->
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="jd_SKUID" label="SKU ID" align="center"></el-table-column>
                <el-table-column prop="jd_SKUmingcheng" label="SKU 名称" align="center"></el-table-column>
                <el-table-column prop="jd_dangqianshijian" label="点击时间" align="center"></el-table-column>
                <el-table-column prop="jd_huafei" label="花费" align="center"></el-table-column>
                <el-table-column prop="jd_zhanxianshu" label="展现数" align="center"></el-table-column>

                <el-table-column prop="jd_dianjishu" label="点击数" align="center"></el-table-column>
                <el-table-column prop="jd_dianjilyu" label="点击率（%）" align="center"></el-table-column>
                <el-table-column prop="jd_pingjundianjichengben" label="平均点击成本" align="center"></el-table-column>
                <el-table-column prop="jd_qiancizhanxianchengben" label="千次展现成本" align="center"></el-table-column>
                <el-table-column prop="jd_zongdingdanxing" label="总订单行" align="center"></el-table-column>
                <el-table-column prop="jd_zongdingdanjine" label="总订单金额" align="center"></el-table-column>
                <el-table-column prop="jd_zongjiagoushu" label="总加购数" align="center"></el-table-column>
                <el-table-column prop="jd_zhuanhualyu" label="转化率（%）" align="center"></el-table-column>
                <el-table-column prop="jd_jiagoulyu" label="加购率（%）" align="center"></el-table-column>
                <el-table-column prop="jd_pingjundingdanchengben" label="平均订单成本" align="center"></el-table-column>
                <el-table-column prop="jd_touchanbi" label="投产比" align="center"></el-table-column>
                <el-table-column prop="jd_zhijiedingdanxing" label="直接订单行" align="center"></el-table-column>
                <el-table-column prop="jd_zhijiedingdanjine" label="直接订单金额" align="center"></el-table-column>
                <el-table-column prop="jd_zhijiejiagoushu" label="直接加购数" align="center"></el-table-column>
                <el-table-column prop="jd_jianjiedingdanxing" label="间接订单行" align="center"></el-table-column>
                <el-table-column prop="jd_jianjiedingdanjine" label="间接订单金额" align="center"></el-table-column>
                <el-table-column prop="jd_jianjiejiagoushu" label="间接加购数" align="center"></el-table-column>
                <el-table-column align="center" label="操作" width="160" class-name="small-padding fixed-width">
                    <template slot-scope="row">
                        <el-button type="danger" size="small" @click="handleDelete(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="width_100" v-if="activeName === 'pduoduo'" style="margin-top: 28px">
            <el-table :data="dataList" style="width: 100%" :header-cell-style="headercellstyle" border height="70vh"
                :key="'pduoduoTable'" ref="orderTable" @selection-change="handleSelectionChange">
                <!-- 批量选择列 -->
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="pd_riqi" label="日期" align="center"></el-table-column>
                <el-table-column prop="pd_zonghuafeiyuan" label="总花费(元)" align="center"></el-table-column>
                <el-table-column prop="pd_chengjiaohuafeiyuan" label="成交花费(元)" align="center"></el-table-column>
                <el-table-column prop="pd_jiaoyieyuan" label="交易额(元)" align="center"></el-table-column>
                <el-table-column prop="pd_shijitouchanbi" label="实际投产比" align="center"></el-table-column>
                <el-table-column prop="pd_jingshijitouchanbi" label="净实际投产比" align="center"></el-table-column>
                <el-table-column prop="pd_jingjiaoyieyuan" label="净交易额（元）" align="center"></el-table-column>
                <el-table-column prop="pd_jingchengjiaobishu" label="净成交笔数" align="center"></el-table-column>
                <el-table-column prop="pd_meibichengjiaohuafeiyuan" label="每笔净成交花费（元）" align="center"></el-table-column>
                <el-table-column prop="pd_jingjiaoyiezhanbi" label="净交易额占比" align="center"></el-table-column>
                <el-table-column prop="pd_chengjiaobishu" label="成交笔数" align="center"></el-table-column>
                <el-table-column prop="pd_meibichengjiaohuafeiyuan" label="每笔成交花费（元）" align="center"></el-table-column>
                <el-table-column prop="pd_meibichengjiaojineyuan" label="每笔成交金额（元）" align="center"></el-table-column>
                <el-table-column prop="pd_tuiguangchangjing" label="全站推广费比" align="center"></el-table-column>
                <el-table-column prop="pd_puguangliang" label="曝光量" align="center"></el-table-column>
                <el-table-column prop="pd_dianjiliang  " label="点击量" align="center"></el-table-column>

                <el-table-column align="center" label="操作" width="160" class-name="small-padding fixed-width">
                    <template slot-scope="row">
                        <el-button type="danger" size="small" @click="handleDelete(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="activeFun" />

        <el-dialog :visible.sync="dialogimportVisible" custom-class="unique-dialog" width="752px"
            :close-on-click-modal="false" :show-close="false">
            <div class="import-mask vue_flex vue_align_center vue_column">
                <div class="import-mask-title vue-font-PingFang-500 color_255 vue_relative">
                    导入订单
                    <img src="../../../../../assets/yimou/gb.png" alt="" class="vue_absolute h" @click="
                        (dialogimportVisible = false),
                        (fileName = ''),
                        (updatafileName = ''),
                        (tempObj.channelVal = ''),
                        (tempObj.typeVal = '')
                        " />
                </div>
                <div class="import-mask-boxs vue_flex vue_column">
                    <div class="import-mask-boxs-inp">
                        <ul class="vue_flex vue_align_center">
                            <li class="vue_flex vue-font-PingFang-500">
                                <span>*</span>
                                <p class="color_35">渠道</p>
                            </li>
                            <li class="import-mask-ul-boxs">
                                <el-select v-model="tempObj.channelVal" placeholder="请选择">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </li>
                        </ul>
                    </div>
                    <div class="import-mask-boxs-inp" v-if="tempObj.channelVal == 2">
                        <ul class="vue_flex vue_align_center">
                            <li class="vue_flex vue-font-PingFang-500">
                                <span>*</span>
                                <p class="color_35">订单类型</p>
                            </li>
                            <li class="import-mask-ul-boxs">
                                <el-select v-model="tempObj.typeVal" placeholder="请选择">
                                    <el-option v-for="item in typeList" :key="item.id" :label="item.title"
                                        :value="item.id"></el-option>
                                </el-select>
                            </li>
                        </ul>
                    </div>

                    <div class="import-mask-boxs-inp">
                        <ul class="vue_flex vue_align_center">
                            <li class="vue_flex vue-font-PingFang-500">
                                <span>*</span>
                                <p class="color_35">店铺</p>
                            </li>
                            <li class="import-mask-ul-boxs">
                                <el-select v-model="tempObj.shopid" placeholder="请选择">
                                    <el-option v-for="item in dpList" :key="item.id" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </li>
                        </ul>
                    </div>

                    <div class="import-mask-boxs-img vue_flex vue_column">
                        <img src="../../../../../assets/yimou/dyb.png" alt="" />
                        <div class="import-mask-boxs-img-view vue_flex vue_align_center vue_flex_between h">
                            <p class="vue-font-PingFang-500 color_35">导入模版</p>
                            <div class="vue-font-PingFang-500 color_255" @click="downloadModel()">
                                下载
                            </div>
                        </div>
                    </div>
                    <div class="import-mask-boxs-upload size_no_repeat vue_flex vue_column vue_align_center">
                        <el-upload class="upload-demo" :http-request="leading" drag action multiple action="/"
                            ref="limit" :show-file-list="false">
                            <div v-if="updatafileName == ''">
                                <img src="../../../../../assets/yimou/cwj.png" alt="" />
                                <p class="upload-title vue-font-PingFang-500">
                                    <span>点击上传</span>
                                </p>
                                <p class="upload-content vue-font-PingFang-500 color_94">
                                    只能上传 excel 文件
                                </p>
                            </div>
                            <div v-else>
                                <img src="../../../../../assets/ym/excel.png" alt="" class="file-icon" />
                                <div style="margin-top: 30px">{{ fileName }}</div>
                            </div>
                        </el-upload>
                    </div>
                </div>
                <div class="import-mask-but vue-font-PingFang-500 color_255 h" @click="toApply">
                    确认
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { windowFun } from "@/utils/utils";
import DonMessage from "@/utils/message";
import Cookies from "js-cookie";
export default {
    components: { Pagination },
    data() {
        return {
            fileName: "",
            updatafileName: "",
            innerWidth: 0,
            innerHeight: 0,
            headercellstyle: {
                backgroundColor: "rgba(245, 247, 250, 1)",
                color: "rgba(51, 3, 0, 1)",
            },

            total: 0,
            listQuery: {
                page: 1,
                limit: 10,
            },

            dialogimportVisible: false,

            activeName: "taobao",
            tabsList: [
                { title: "天猫淘宝", activeVal: "taobao" },
                { title: "京东", activeVal: "jingdong" },
                { title: "拼多多", activeVal: "pduoduo" },
            ],

            wenzi: "",
            searchValue: "",
            dataList: [],
            taobaoList: [
                {
                    time: "4290116007981676110",
                    zhutid: "4290116007981676110",
                    zhuttype: "商品",
                    zhutname: "野营天幕杂物收纳袋户外露营折叠椅帐篷收纳包...",
                    zhanxiannum: "32",
                },
                {
                    time: "4290116007981676110",
                    zhutid: "4290116007981676110",
                    zhuttype: "商品",
                    zhutname: "野营天幕杂物收纳袋户外露营折叠椅帐篷收纳包...",
                    zhanxiannum: "32",
                },
                {
                    time: "4290116007981676110",
                    zhutid: "4290116007981676110",
                    zhuttype: "商品",
                    zhutname: "野营天幕杂物收纳袋户外露营折叠椅帐篷收纳包...",
                    zhanxiannum: "32",
                },
            ],

            jingdongList: [
                {
                    skutitle:
                        "zhengfly户外露营加厚野餐垫公园防潮垫便携式草地地垫可折叠地席 1.5*2米特厚6MM超声波萌兔",
                    skutid: "4290116007981676110",
                    diantime: "20250621~20250621",
                    price: "32 ",
                    num: "32",
                },
                {
                    skutitle:
                        "zhengfly户外露营加厚野餐垫公园防潮垫便携式草地地垫可折叠地席 1.5*2米特厚6MM超声波萌兔",
                    skutid: "4290116007981676110",
                    diantime: "20250621~20250621",
                    price: "32 ",
                    num: "32",
                },
                {
                    skutitle:
                        "zhengfly户外露营加厚野餐垫公园防潮垫便携式草地地垫可折叠地席 1.5*2米特厚6MM超声波萌兔",
                    skutid: "4290116007981676110",
                    diantime: "20250621~20250621",
                    price: "32 ",
                    num: "32",
                },
            ],

            pduoduoList: [
                {
                    time: "2025-03-23",
                    allprice: "",
                    chengprice: "",
                    jiaoprice: "1.49",
                    sijibi: "1.49",
                    jingbi: "1.49",
                },
                {
                    time: "2025-03-23",
                    allprice: "",
                    chengprice: "",
                    jiaoprice: "1.49",
                    sijibi: "1.49",
                    jingbi: "1.49",
                },
                {
                    time: "2025-03-23",
                    allprice: "",
                    chengprice: "",
                    jiaoprice: "1.49",
                    sijibi: "1.49",
                    jingbi: "1.49",
                },
            ],

            options: [
                { value: "1", label: "淘宝" },
                { value: "2", label: "京东" },
                { value: "3", label: "拼多多" },
            ],
            tempObj: {
                channelVal: "",
                typeVal: "",
                shopid:""
            },

            typeId: 1,
            typeList: [
                { title: "平台账单Ⅰ类", id: 1 },
                { title: "平台账单Ⅱ类", id: 2 },
            ],
            // 新增批量删除相关数据
            selectedRows: [],
            batchDeleteLoading: false,
            dpList: [],
        };
    },

    created() {
        this.innerWidth = windowFun().innerWidth;
        this.innerHeight = windowFun().innerHeight;
        this.activeFun();
        this.getdpListFun();
    },

    methods: {
        // 新增：处理表格选中行变化
        handleSelectionChange(val) {
            this.selectedRows = val;
        },

        // 新增：批量删除方法（适配delTuiguang接口）
        async batchDelete() {
            // 1. 校验选中数据
            if (this.selectedRows.length === 0) {
                return DonMessage.warning("请先选择需要删除的推广数据");
            }

            // 2. 二次确认
            try {
                await this.$confirm(
                    `您确定要删除选中的 ${this.selectedRows.length} 条推广数据吗？`,
                    "警告！",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }
                );

                // 3. 开始批量删除
                this.batchDeleteLoading = true;
                let successCount = 0;
                let failCount = 0;

                // 4. 循环调用删除接口
                for (const row of this.selectedRows) {
                    try {
                        const res = await this.$http.get(this.$urls.delTuiguang, {
                            id: row.id,
                        });
                        if (res.errcode === 0) {
                            successCount++;
                        } else {
                            failCount++;
                            console.error(`删除推广数据 ${row.id} 失败：`, res.errmsg);
                        }
                    } catch (err) {
                        failCount++;
                        console.error(`删除推广数据 ${row.id} 异常：`, err);
                    }
                }

                // 5. 结果提示
                if (failCount === 0) {
                    DonMessage.success(`批量删除成功！共删除 ${successCount} 条推广数据`);
                } else if (successCount === 0) {
                    DonMessage.error(`批量删除失败！${failCount} 条推广数据删除失败`);
                } else {
                    DonMessage.warning(`批量删除完成！成功 ${successCount} 条，失败 ${failCount} 条`);
                }

                // 6. 刷新列表 + 清空选中状态
                this.activeFun();
                if (this.$refs.orderTable) {
                    this.$refs.orderTable.clearSelection();
                }
                this.selectedRows = [];
            } catch (err) {
                // 取消删除
                DonMessage.info("已取消批量删除");
            } finally {
                // 关闭加载状态
                this.batchDeleteLoading = false;
            }
        },

        //删除
        handleDelete(row) {
            this.$confirm("您确定删除么?", "警告！", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                const res = await this.$http.get(this.$urls.delTuiguang, { id: row.row.id });
                console.log("----", res);
                if (res.errcode == 0) {
                    DonMessage.success("删除成功");
                    this.activeFun();
                } else {
                    DonMessage.error("删除失败");
                }
            })
                .catch((err) => {
                    console.log(err);
                });
        },

        downloadModel() {
            let url = "";

            if (this.activeName === "taobao")
                url =
                    "https://img.yimoubi.com/1-static-moban/%E5%A4%A9%E7%8C%AB%E6%8E%A8%E5%B9%BF%E8%B4%A6%E5%8D%95%E6%A8%A1%E6%9D%BF%E8%A1%A8.xlsx";
            if (this.activeName === "jingdong")
                url =
                    "https://img.yimoubi.com/1-static-moban/%E4%BA%AC%E4%B8%9C%E6%8E%A8%E5%B9%BF%E8%B4%A6%E5%8D%95%E6%A8%A1%E6%9D%BF%E8%A1%A8.xlsx";
            if (this.activeName === "pduoduo")
                url =
                    "https://img.yimoubi.com/1-static-moban/%E6%8B%BC%E5%A4%9A%E5%A4%9A%E6%8E%A8%E5%B9%BF%E8%B4%A6%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx";

            const link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", "模板.xlsx");
            document.body.appendChild(link);
            link.click();
        },

        async toApply() {
            if (!this.tempObj.channelVal) return DonMessage.error(`请选择渠道`);
            if (!this.tempObj.shopid) return DonMessage.error(`请选择店铺`);
            if (this.tempObj.channelVal == 2 && !this.tempObj.typeVal)
                return DonMessage.error(`请选择渠道类型`);
            if (!this.updatafileName) return DonMessage.error(`请上传文件`);
            let params = {
                type: this.tempObj.channelVal,
                file_path: this.updatafileName,
                shopid:this.tempObj.shopid,
            };

            if (this.tempObj.channelVal == 2) {
                params["jd_type"] = this.tempObj.typeVal;
            }

            const res = await this.$http.post(this.$urls.importTuiguangs, params);

            if (res.errcode != 0) return DonMessage.error(res.errmsg);

            this.dialogimportVisible = false;
            this.tempObj.channelVal = "";
            this.updatafileName = "";
            this.fileName = "";
            this.activeFun();
        },
        async leading(param) {
            this.listLoading = true;
            let fileObj = param.file;
            let uploadForm = new FormData();
            uploadForm.append("file", fileObj);
            const res = await this.$http.postfile(this.$urls.uploadFile, uploadForm);
            this.fileName = param.file.name;
            this.updatafileName = res.data.file_path;
        },
        handleClick(row) {
            if (this.activeName === row.activeVal) return;
            this.activeName = row.activeVal;
            // 新增：切换标签时清空选中状态
            if (this.$refs.orderTable) {
                this.$refs.orderTable.clearSelection();
            }
            this.selectedRows = [];
            this.activeFun();
        },

        async activeFun() {
            let ty = "";
            if (this.activeName == "taobao") ty = "1";
            if (this.activeName == "jingdong") ty = "2";
            if (this.activeName == "pduoduo") ty = "3";
            let params = {
                page: this.listQuery.page,
                limit: this.listQuery.limit,
                type: ty,
                jd_type: ty == 2 ? this.typeId : "",
                searchText: this.searchValue,
            };
            const res = await this.$http.get(this.$urls.getTuiguangList, params);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.dataList = res.list;
            this.total = res.count;
        },
        // 店铺列表
        async getdpListFun() {
            const res = await this.$http.get(this.$urls.getshoplist, {
                page: 1,
                limit: 10000,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.dpList = res.list;
        },
    },
};
</script>

<style lang="scss" scoped>
.import-mask-boxs-img {
    margin-bottom: 21px;
    margin-top: 40px;

    img {
        width: 118px;
        height: auto;
    }

    .import-mask-boxs-img-view {
        width: fit-content;
        padding: 0px 14px 0px 17px;
        height: 68px;
        background: #f5f5f5;
        margin-top: 17px;
        border-radius: 10px;

        p {
            font-size: 18px;
            line-height: 18px;
        }

        div {
            width: 90px;
            height: 37px;
            margin-left: 48px;
            line-height: 37px;
            text-align: center;
            font-size: 14px;
            background: #195cf8;
            border-radius: 5px;
        }
    }

    .import-mask-boxs-img-text {
        font-size: 14px;
        line-height: 14px;
        margin-top: 11px;
    }
}

.plateorder {
    padding: 22px;
}

.plateorder-tabs {
    background: rgba(245, 245, 245, 1);
    border-radius: 10px;
    padding: 9px 18px 8px 47px;

    .plateorder-tabs-boxs {
        gap: 68px;

        li {
            p {
                font-size: 26px;
            }

            div {
                width: 100%;
                height: 3px;
                background: rgba(25, 92, 248, 1);
                border-radius: 2px;
                bottom: -12px;
                left: 0px;
            }
        }

        .active {
            color: rgba(25, 92, 248, 1);
        }

        .activenot {
            color: rgba(35, 35, 35, 1);
        }
    }

    .plateorder-tabs-input {
        .shaixuan_item {
            width: 350px;
            height: 54px;
            background: #ffffff;
            border-radius: 10px;
            padding: 0 20px;
            margin-right: 22px;

            .shaixuan_item_con {
                p {
                    font-size: 18px;
                }

                .shaixuan_item_arr {
                    width: 13px;
                    height: 8px;
                    margin-left: 10px;
                }

                .shaixuan_item_icon {
                    width: 29px;
                    height: 24px;
                    margin-right: 10px;
                }
            }
        }

        .top_bar_inp {
            width: 372px;
            height: 54px;
            background: rgba(255, 255, 255, 1);
            border-radius: 10px;
            margin-right: 32px;
            padding: 0 11px;

            .top_bar_inp_img1 {
                width: 24px;
                height: 24px;
                margin-right: 12px;
            }

            .top_bar_inp_inp {
                width: 282px;
            }
        }

        .plateorder-tabs-input-but {
            width: 131px;
            height: 54px;
            background: rgba(25, 92, 248, 1);
            border-radius: 10px;
            font-size: 20px;
            line-height: 54px;
            text-align: center;
        }
    }
}

.import-mask {
    width: 100%;
    border-radius: 15px;
    background-image: url("../../../../../assets/yimou/tb.png");
    background-size: 100% 51px;
    background-repeat: no-repeat;
    padding-bottom: 40px;

    .import-mask-title {
        width: 100%;
        height: 51px;
        line-height: 51px;
        text-align: center;
        font-size: 18px;

        img {
            width: 13px;
            height: 13px;
            top: 21px;
            right: 20px;
        }
    }

    .import-mask-boxs {
        width: 650px;
        margin-top: 34px;

        .import-mask-boxs-inp {
            width: 100%;
            background: rgba(245, 245, 245, 1);
            border-radius: 10px;
            padding: 11px 22px;
            margin-bottom: 19px;

            ul {
                li:nth-of-type(1) {
                    width: 145px;
                    font-size: 18px;
                    line-height: 18px;

                    span {
                        color: rgba(255, 0, 0, 1);
                    }
                }
            }
        }

        .import-mask-boxs-upload {
            width: 100%;
            height: 168px;
            margin: 10px 0px 34px;
            background-image: url("../../../../../assets/yimou/hsk.png");

            img {
                width: 35px;
                height: 31px;
                margin-top: 39px;
            }

            .upload-title {
                font-size: 16px;
                line-height: 16px;
                margin: 16px 0px 13px;

                span:nth-of-type(2) {
                    color: rgba(20, 75, 201, 1);
                }
            }

            .upload-content {
                font-size: 14px;
                line-height: 14px;
            }
        }

        .import-mask-ul-boxs {
            width: 24vw;
        }
    }

    .import-mask-but {
        width: 266px;
        height: 47px;
        line-height: 47px;
        text-align: center;
        background: rgba(25, 92, 248, 1);
        border-radius: 10px;
        font-size: 17px;
    }
}

.plateorder-type {
    margin: 23px 0px;

    div {
        width: 155px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        border-radius: 10px;
        margin-right: 14px;
    }

    .active {
        color: rgba(255, 255, 255, 1);
        background: rgba(25, 92, 248, 1);
    }

    .activenot {
        color: rgba(35, 35, 35, 1);
        background: rgba(245, 245, 245, 1);
    }
}

.import-mask-boxs-inp .el-input /deep/.el-input__inner {
    border: none !important;
    font-size: 18px;
}

.revenbook-drawer .el-input /deep/.el-input__inner {
    border: none !important;
    background: none !important;
    font-size: 18px;
}

.el-select {
    width: 100% !important;
}

.el-select /deep/.el-input__inner {
    width: 100%;
    border: none !important;
    background: none !important;
    font-size: 18px;
}

.el-select /deep/.el-select__caret {
    color: #000000 !important;
}

.upload-demo /deep/.el-upload-dragger {
    background: none !important;
    border: none !important;
    border-radius: 0px !important;
    width: 640px !important;
    height: 168px;
}

.shaixuan_item {
    .el-input /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }

    .el-input /deep/.el-input__prefix {
        display: none !important;
    }

    .el-select /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }
}

/* 批量删除按钮样式 - 已设置margin-top:20px */
.batch-delete-container {
    .el-button {
        padding: 8px 15px;
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/level1/data_center/promotion/index.vue